import { DEFAULT_FILTERS } from '../../config';

const buildCssFilter = (filters = {}) => {
  const f = { ...DEFAULT_FILTERS, ...filters };
  const parts = [];

  if (f.blur) {
    parts.push(`blur(${f.blur}px)`);
  }
  if (f.brightness) {
    parts.push(`brightness(${1 + f.brightness / 100})`);
  }
  if (f.contrast) {
    parts.push(`contrast(${1 + f.contrast / 100})`);
  }
  if (f.saturation) {
    parts.push(`saturate(${1 + f.saturation / 100})`);
  }

  return parts.length ? parts.join(' ') : 'none';
};

const applyTemperatureOverlay = (ctx, x, y, width, height, temperature) => {
  if (!temperature) {
    return;
  }

  const t = Math.max(-100, Math.min(100, temperature)) / 100;
  ctx.save();
  ctx.globalCompositeOperation = 'soft-light';
  if (t > 0) {
    ctx.fillStyle = `rgba(255, 160, 60, ${0.35 * t})`;
  } else {
    ctx.fillStyle = `rgba(60, 140, 255, ${0.35 * -t})`;
  }
  ctx.fillRect(x, y, width, height);
  ctx.restore();
};

const renderFilteredCanvas = (source, sx, sy, sw, sh, destWidth, destHeight, filters) => {
  const width = Math.max(1, Math.round(destWidth));
  const height = Math.max(1, Math.round(destHeight));
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  const ctx = canvas.getContext('2d');
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = 'high';
  ctx.filter = buildCssFilter(filters);
  ctx.drawImage(source, sx, sy, sw, sh, 0, 0, width, height);
  ctx.filter = 'none';

  if (filters?.temperature) {
    const alphaMask = document.createElement('canvas');
    alphaMask.width = width;
    alphaMask.height = height;
    alphaMask.getContext('2d').drawImage(canvas, 0, 0);

    applyTemperatureOverlay(ctx, 0, 0, width, height, filters.temperature);

    ctx.globalCompositeOperation = 'destination-in';
    ctx.drawImage(alphaMask, 0, 0);
    ctx.globalCompositeOperation = 'source-over';
  }

  return canvas;
};

export const applyCssFiltersToImageData = (imageData, filters) => {
  const width = imageData.width;
  const height = imageData.height;
  const source = document.createElement('canvas');
  source.width = width;
  source.height = height;
  source.getContext('2d').putImageData(imageData, 0, 0);

  const filtered = renderFilteredCanvas(source, 0, 0, width, height, width, height, filters);
  const next = filtered.getContext('2d').getImageData(0, 0, width, height);
  imageData.data.set(next.data);
};
